// Denial envelope measured in contract-fixtures/scopely/auth/*: every error
// body is { detail, code, request_id }, plus field_errors on serializer 400s
// (login/empty-body-validation).

export interface AuthErrorBody {
  detail?: string;
  code?: string;
  request_id?: string;
  field_errors?: Record<string, string[]>;
}

export class AuthApiError extends Error {
  readonly status: number;
  readonly detail?: string;
  readonly code?: string;
  readonly requestId?: string;
  readonly fieldErrors?: Record<string, string[]>;

  constructor(status: number, body: AuthErrorBody) {
    super(body.detail ?? `Auth request failed (${status})`);
    this.name = "AuthApiError";
    this.status = status;
    this.detail = body.detail;
    this.code = body.code;
    this.requestId = body.request_id;
    this.fieldErrors = body.field_errors;
  }
}

export async function authApiErrorFromResponse(res: Response): Promise<AuthApiError> {
  let body: AuthErrorBody = {};
  try {
    body = (await res.json()) as AuthErrorBody;
  } catch {
    // Non-JSON denial (e.g. a gateway 502): surface the bare status.
  }
  return new AuthApiError(res.status, body);
}
